import React from 'react'
import createReactClass from 'create-react-class'
import _ from 'lodash'

import i18n from 'live/services/i18n'
import FormGroup from 'live/components/forms/ui/form-group'
import TableForm from 'live/components/forms/ui/table-form'
import WellRigConfigModal from './components/well-rig-config-modal'
import ActionToggle from 'live/components/ui/action-toggle'
import styled from 'styled-components'
import PasswordInput from 'live/components/forms/ui/UserTable/PasswordInput'

const WELLS_CONFIG = [
    {
        label: i18n('Enabled'),
        name: 'enabled',
        type: 'toggle',
        cols: 2
    },
    {
        label: i18n('Remote Well name'),
        name: 'name',
        type: 'readonly',
        cols: 3
    },
    {
        label: i18n('Local Rig name'),
        name: 'rig',
        type: 'readonly',
        cols: 2
    },
    {
        label: i18n('Total Configured channels'),
        name: 'curves',
        type: 'readonly',
        cols: 4
    }
]
const ImportForm = createReactClass({
    getInitialState: function () {
        return {
            showNewWellModal: false,
            showWellConfigModal: false,
            nameFilter: '*',
            selectedWell: {
                index: null,
                data: null
            }
        }
    },

    toggleEnabled: function () {
        let { object, applyObj } = this.props
        let config = object.config

        config.fetcher.enabled = !config.fetcher.enabled
        applyObj({ config: config })
    },

    onChangeInput: function ({ target }) {
        let { name, value } = target
        let { object, applyObj } = this.props
        let config = object.config

        config.fetcher[name] = value
        applyObj({ config: config })
    },

    setWellName: function (nameFilter) {
        let selectedWell = {
            index: null,
            data: null
        }

        this.setState({ nameFilter, selectedWell })
        this.toggleModal('showWellConfigModal')
    },

    selectWellToEdit: function (index, data) {
        let selectedWell = {
            index,
            data
        }

        this.setState({ selectedWell })
        this.toggleModal('showWellRigConfigModal')
    },

    onChangeWell: function (index, well) {
        let { object, applyObj } = this.props
        let config = object.config

        if (typeof index === 'number')
            config.fetcher['wells'][index] = {
                ...config.fetcher['wells'][index],
                ...well
            }
        else
            config.fetcher['wells'].push({
                enabled: true,
                ...well
            })

        applyObj({ config: config })

        let selectedWell = {
            index: null,
            data: null
        }

        this.setState({ selectedWell })

        this.updatePoints()
    },

    onChangeWells: function (wells) {
        let { object, applyObj } = this.props
        let config = object.config

        config.fetcher['wells'] = wells
        applyObj({ config: config })

        this.updatePoints()
    },

    compareCurvePoints: function (i, v) {
        return (
            i.property === v.webid &&
            ((!i.curve && !v.name) ||
                (i.curve &&
                    v.name &&
                    v.well &&
                    i.curve.toUpperCase() === v.name.substr(v.well?.length + 1).toUpperCase())) &&
            ((!i.mnemonic && !v.mnemonic) ||
                (v.mnemonic && i.mnemonic && i.mnemonic.toUpperCase() === v.mnemonic.toUpperCase()))
        )
    },
    getWellConfig: function () {
        let { object } = this.props
        let { config } = object
        let { selectedWell } = this.state

        let stateConfig = selectedWell && selectedWell.data && selectedWell.data.config
        let filteredPoints = config.fetcher.points.filter(
            v => stateConfig && stateConfig.some(i => this.compareCurvePoints(i, v))
        )

        return _.map(stateConfig, c => {
            let point = _.find(filteredPoints, point => this.compareCurvePoints(c, point))

            return {
                curve: (c && c.curve) || (point && point.inputName) || '',
                mnemonic: (c && c.mnemonic) || (point && point.mnemonic) || '',
                property: (c && c.property) || null,
                unit: (c && c.unit) || null,
                name: (point && point.mnemonic) || null
            }
        })
    },

    enableAddNewWell: function () {
        let { object } = this.props
        let { config } = object
        let { fetcher } = config

        let hasConnectionData = fetcher && fetcher.uri

        return hasConnectionData
    },

    updateWells: function () {
        let { object, applyObj } = this.props
        let config = object.config
        let curves = config.fetcher.curves

        let wells = _.map(config.fetcher.wells, well => {
            let config = []

            _.each(well.config, c => {
                let validCurve = _.find(curves, curve => curve.inputName === c.curve)

                if (validCurve)
                    config.push({
                        ...c,
                        curve: validCurve.inputName
                    })
            })

            return {
                ...well,
                config,
                curves: _.map(config, c => c.curve).join(', ')
            }
        })

        config.fetcher['wells'] = wells
        applyObj({ config: config })

        this.updatePoints()
    },
    addWell: function () {
        this.setState({ selectedWell: null }, () => this.toggleModal('showWellRigConfigModal'))
    },

    updatePoints: function () {
        let { object, applyObj } = this.props
        let config = object.config
        let points = []

        const curves = config.fetcher.curves.reduce((obj, item) => {
            obj[item.inputName] = { uom: item.inputUnit, mnemonic: item.outputCurve }

            return obj
        }, {})
        let toUpperCaseId = (str = '') => str.replace(/ /g, '-').toUpperCase()

        _.each(config.fetcher.wells, well => {
            _.each(well.config, w => {
                points.push({
                    enabled: well.enabled,
                    webid: w.property,
                    name: `${toUpperCaseId(well.name)}-${toUpperCaseId(w.curve)}`,
                    mnemonic: w.mnemonic || (curves[w.curve] && curves[w.curve].mnemonic) || '',
                    well: well.name,
                    rig: well.rig,
                    rigId: well.rigId,
                    uom: w.unit || '',
                    inputName: w.curve || ''
                })
            })
        })
        config.fetcher['points'] = points
        applyObj({ config: config })
    },

    toggleModal: function (modal) {
        this.setState({
            [modal]: !this.state[modal]
        })
    },
    toggleInsertEventRaw: function () {
        let { object, applyObj } = this.props
        let config = object.config

        config.fetcher.insertEventRaw = !config.fetcher.insertEventRaw
        applyObj({ config: config })
    },
    render: function () {
        const { object } = this.props
        const { config } = object
        const enableAddNewWell = this.enableAddNewWell()

        const wellsData = _.cloneDeep(config.fetcher.wells)

        _.each(wellsData, w => {
            w.curves = '' + w?.config?.length
        })

        const { nameFilter, selectedWell } = this.state

        return (
            <div className="export-form">
                <div className="form-area">
                    <h3>{i18n('Import')}</h3>
                    <div className="form-group clearfix">
                        <label className="radio regular">
                            <input
                                type="radio"
                                name="fetcher-enabled"
                                checked={config.fetcher.enabled}
                                onChange={this.toggleEnabled}
                            />
                            {i18n('Enabled')}
                        </label>
                        <label className="radio regular">
                            <input
                                type="radio"
                                name="fetcher-enabled"
                                checked={!config.fetcher.enabled}
                                onChange={this.toggleEnabled}
                            />
                            {i18n('Disabled')}
                        </label>
                    </div>

                    <h3>{i18n('Connection')}</h3>
                    <FormGroup
                        type="text"
                        label={
                            <span>
                                URL ({i18n('import')}) <abbr title="required">*</abbr>
                            </span>
                        }
                        name="uri"
                        value={config.fetcher.uri}
                        placeholder={'http://0.0.0.0:12345/piwebapi/'}
                        onChange={this.onChangeInput}
                    />

                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup
                                type="text"
                                label={i18n('Username')}
                                name="username"
                                value={config.fetcher.username}
                                onChange={this.onChangeInput}
                            />
                        </div>
                        <div className="col-md-6">
                            {/* <FormGroup
                                type="text"
                                label={i18n('Password')}
                                name="password"
                                value={config.fetcher.password}
                                onChange={this.onChangeInput} /> */}
                            <PasswordInput
                                label={i18n('Password')}
                                id={(object?.qualifier ? (object?.type + '/' + object?.qualifier) : object?.type) || ''}
                                name="password"
                                initPassword={this.props.self?.state?.original?.config?.fetcher?.password}
                                onChange={newPassword => {
                                    this.onChangeInput({
                                        target: {
                                            name: 'password',
                                            value: newPassword
                                        }
                                    })
                                    this.props.self.setState(prev => {
                                        const newState = _.cloneDeep(prev)
                                        newState.object.config.fetcher.password = newPassword
                                        return newState
                                    })
                                }}
                                setEditing={this.props.self.state.setHasUnSavedPassword}
                            />
                        </div>
                    </div>

                    <FormGroup
                        type="text"
                        label={<span>{i18n('Server Path')}</span>}
                        name="server_path"
                        value={config.fetcher.server_path}
                        inputPrefix="\\"
                        onChange={this.onChangeInput}
                    />

                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup
                                type="number"
                                label={
                                    <span>
                                        {i18n('Fetch Interval')} ({i18n('ms')}) <abbr title="required">*</abbr>
                                    </span>
                                }
                                name="fetch_interval"
                                value={parseInt(config.fetcher.fetch_interval)}
                                onChange={this.onChangeInput}
                            />
                        </div>
                        <div className="col-md-6">
                            <FormGroup
                                type="number"
                                label={
                                    <span>
                                        {i18n('Retry Interval')} ({i18n('ms')}) <abbr title="required">*</abbr>
                                    </span>
                                }
                                name="retry_interval"
                                value={parseInt(config.fetcher.retry_interval)}
                                onChange={this.onChangeInput}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup
                                type="number"
                                label={
                                    <span>
                                        {i18n('Timeout')} ({i18n('ms')}) <abbr title="required">*</abbr>
                                    </span>
                                }
                                name="timeout"
                                value={parseInt(config.fetcher.timeout)}
                                onChange={this.onChangeInput}
                            />
                        </div>
                        <div className="col-md-6">
                            <FormGroup
                                type="number"
                                label={
                                    <span>
                                        {i18n('TTL')} ({i18n('ms')}) <abbr title="required">*</abbr>
                                    </span>
                                }
                                name="ttl"
                                value={parseInt(config.fetcher.ttl)}
                                onChange={this.onChangeInput}
                            />
                        </div>
                    </div>

                    <h3>{i18n('Identification')}</h3>
                    <FormGroup
                        type="text"
                        label={i18n('Event type')}
                        name="event_type"
                        value={config.fetcher.event_type}
                        onChange={this.onChangeInput}
                    />
                </div>

                <StyledToggle>
                    <ActionToggle
                        className="centered"
                        active={config.fetcher.insertEventRaw}
                        onChange={this.toggleInsertEventRaw}
                    />
                    <label>{i18n('Insert copy of raw event in the normalized event')}</label>
                </StyledToggle>

                <div className="tables">
                    <h3 className="subtitle-label">{i18n('Selected Wells')}</h3>
                    {!enableAddNewWell ? (
                        <div className="warning-msg">
                            {i18n(
                                'You need to inform Connection credentials and set the "SAMTER Standard Channels" before add new wells.'
                            )}
                        </div>
                    ) : (
                            ''
                        )}
                    <TableForm
                        visibleRows={0}
                        fields={WELLS_CONFIG}
                        data={wellsData || []}
                        onChange={this.onChangeWells}
                        onEdit={this.selectWellToEdit}
                        addButtonLabel={<span>+ {i18n('New well')}</span>}
                        addButtonDisabled={!enableAddNewWell}
                        onAdd={this.addWell}
                    />
                    {this.state.showWellRigConfigModal ? (
                        <WellRigConfigModal
                            show={true}
                            onHide={this.toggleModal.bind(this, 'showWellRigConfigModal')}
                            config={config.fetcher}
                            wellName={(selectedWell && selectedWell.data && selectedWell.data.name) || nameFilter}
                            rigName={(selectedWell && selectedWell.data && selectedWell.data.rig) || ''}
                            rigId={(selectedWell && selectedWell.data && selectedWell.data.rigId) || ''}
                            data={this.getWellConfig()}
                            index={selectedWell && selectedWell.index}
                            onApply={this.onChangeWell}
                            object={object}
                        />
                    ) : (
                            ''
                        )}
                </div>
            </div>
        )
    }
})
const StyledToggle = styled.div`
    display: flex;

    .action-toggle {
        top: -3px;
    }
`

module.exports = ImportForm
